import gql from 'graphql-tag';

export const answerFieldsFragment = gql`
  fragment AdminAnswerFields on Answer {
    textValue
    numericValue
    booleanValue
    textlistValue
    booleanlistValue
    numericlistValue
    blocklistValue
  }
`;